import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getTrendingDeals } from "../../services/searchService";
import { groupProducts } from "../../services/groupProducts";
import { useAuth } from "../../services/authContext";
import { Products } from "./Card";
import Loader from "../Loader";
import AuthModal from "../AuthModal";
import "./ProductsShowcase.css";

const GUEST_LIMIT = 40;
const MEMBER_LIMIT = 150;

export default function ProductsShowcase() {
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAuth, setShowAuth] = useState(false);

  useEffect(() => {
    async function fetchProducts() {
      setLoading(true);
      try {
        const data = await getTrendingDeals(user ? MEMBER_LIMIT : GUEST_LIMIT);
        setProducts(groupProducts(data));
      } catch (e) {
        setProducts([]);
      }
      setLoading(false);
    }
    fetchProducts();
  }, [user]);

  return (
    <div className="showcase-page">
      <div className="showcase-header">
        <h1 className="showcase-title">Trending Deals</h1>
        <p className="showcase-subtitle">The hottest markdowns across your favorite brands</p>
      </div>
      <div className="showcase-content">
        {loading ? (
          <Loader />
        ) : products.length > 0 ? (
          <>
            <Products products={products} />
            {!user ? (
              <div className="showcase-login-footer">
                <div className="showcase-login-icon">🔒</div>
                <h2 className="showcase-login-title">See more deals</h2>
                <p className="showcase-login-subtitle">
                  Log in to unlock the full catalog, filters, and personalized deal alerts.
                </p>
                <button className="showcase-login-btn" onClick={() => setShowAuth(true)}>
                  Log In / Sign Up
                </button>
              </div>
            ) : (
              <Link to="/services" className="showcase-browse-all">
                Browse All Deals <span aria-hidden="true">→</span>
              </Link>
            )}
          </>
        ) : (
          <p className="showcase-empty">No products available right now.</p>
        )}
      </div>
      <AuthModal isOpen={showAuth} onClose={() => setShowAuth(false)} />
    </div>
  );
}
